<template>
  <div id="instructions">
    <b-container class="container--max-lg">
      <div class="mb-3">
        <h1>{{ $t("lang.label_quantumSafeApps_instructions") }}</h1>
      </div>
      <div class="c-dashboard__card">
        <div class="mb-3">
          <router-link class="c-link" to="/quantum-safe-apps">
            <svg viewBox="0 0 14 20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <defs>
                <path
                  d="M18.393 19.509L9.464 12l8.929-7.509a.5.5 0 0 0 .06-.704l-1.287-1.531a.5.5 0 0 0-.704-.06L6.168 10.851a1.5 1.5 0 0 0 0 2.296l10.294 8.657a.5.5 0 0 0 .704-.06l1.287-1.532a.5.5 0 0 0-.06-.704z"
                  id="ic-angle-left_svg__a"
                />
              </defs>
              <use fill="currentColor" xlink:href="#ic-angle-left_svg__a" transform="translate(-5 -2)" fill-rule="evenodd" />
            </svg>
            <span>{{ $t("lang.label_back") }}</span></router-link
          >
        </div>
      </div>
      <b-card>
        <b-tabs content-class="mt-3">
          <b-tab :title="$t('lang.label_quantumSafeApps_sunray')" :active="this.$route.params.openTab === 'sunray'">
            <div class="mt-3 mb-4">
              <b-card-title>
                Sunray
              </b-card-title>
              <div class="mb-2">
                <p>
                  {{ $t("lang.info_quantumSafeApps_instructions_sunray_1") }}
                  <router-link :to="{ name: 'login-and-registration' }">https://pqc-pki.mtg.de</router-link>
                  {{ $t("lang.info_quantumSafeApps_instructions_sunray_2") }}
                  <b-img src="images/layout/pqc-address-bar.jpg" fluid alt="Fluid image"></b-img>
                </p>

                <p>
                  {{ $t("lang.info_quantumSafeApps_instructions_sunray_3") }}
                  <b-img src="images/layout/pqc-ciphersuite.jpg" fluid alt="Fluid image"></b-img>
                </p>
              </div>

              <div class="mb-2">
                <h6>{{ $t("lang.info_quantumSafeApps_instructions_installation") }}</h6>
                <p>
                  {{ $t("lang.info_quantumSafeApps_instructions_installation_windows_sunray") }}
                </p>

                <p>
                  {{ $t("lang.info_quantumSafeApps_instructions_installation_mac") }}
                </p>
              </div>
            </div>
            <div role="tablist">
              <div class="mb-3">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-sunray-1 variant="primary">{{ $t("lang.label_quantumSafeApps_instructions_pkcs11") }}</b-button>
                </b-card-header>
                <b-collapse id="accordion-sunray-1" accordion="sunray-accordion-1" role="tabpanel">
                  <b-card-body>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_1") }} </b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_2") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_3") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_4") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_5") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_6") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_7") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_8") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_pkcs11_9") }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </div>

              <div>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-sunray-2 variant="primary">{{ $t("lang.label_quantumSafeApps_instructions_ca") }}</b-button>
                </b-card-header>
                <b-collapse id="accordion-sunray-2" accordion="sunray-accordion-2" role="tabpanel">
                  <b-card-body>
                    <b-card-text
                      ><i> Note: </i>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_note_1") }} Sphincs<sup>+</sup>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_note_2") }}
                    </b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_1") }} </b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_2") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_3") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_4") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_5") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_6") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_7") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_8") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_9") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunray_ca_10") }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </div>
            </div>
          </b-tab>
          <b-tab :title="$t('lang.label_quantumSafeApps_sunbeam')" :active="this.$route.params.openTab === 'sunbeam'">
            <div class="mt-3 mb-4">
              <b-card-title>
                Sunbeam
              </b-card-title>

              <div class="mb-2">
                <h6>{{ $t("lang.info_quantumSafeApps_instructions_installation") }}</h6>
                <p>
                  {{ $t("lang.info_quantumSafeApps_instructions_installation_windows_sunbeam") }}
                </p>

                <p>
                  {{ $t("lang.info_quantumSafeApps_instructions_installation_mac") }}
                </p>
              </div>
            </div>
            <div role="tablist">
              <div class="mb-3">
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-sunbeam-1 variant="primary">{{ $t("lang.label_quantumSafeApps_instructions_pkcs11") }}</b-button>
                </b-card-header>
                <b-collapse id="accordion-sunbeam-1" accordion="sunbeam-accordion-1" role="tabpanel">
                  <b-card-body>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_1") }} </b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_2") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_3") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_4") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_5") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_6") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_7") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_8") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_pkcs11_9") }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </div>

              <div>
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-button block href="#" v-b-toggle.accordion-sunbeam-2 variant="primary">{{ $t("lang.label_quantumSafeApps_instructions_ca") }}</b-button>
                </b-card-header>
                <b-collapse id="accordion-sunbeam-2" accordion="sunbeam-accordion-2" role="tabpanel">
                  <b-card-body>
                    <b-card-text
                      ><i> Note: </i>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_note_1") }} Sphincs<sup>+</sup>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_note_2") }}
                    </b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_1") }} </b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_2") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_3") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_4") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_5") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_6") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_7") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_8") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_9") }}</b-card-text>
                    <b-card-text>{{ $t("lang.info_quantumSafeApps_instructions_sunbeam_ca_10") }}</b-card-text>
                  </b-card-body>
                </b-collapse>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </b-card>
    </b-container>
  </div>
</template>
<script>
export default {
  name: "QuantumSafeAppsInstructions"
};
</script>

<style scoped></style>
